import {darkBrandPalette, lightBrandPalette} from '../styles/brandColors';
import {alphas, greys, greysDark, palette} from '../styles/colorStyles';
import {borderRadiusPrimitive} from '../styles/primitives/borderRadiusPrimitive';
import {spacingPrimitive} from '../styles/primitives/spacingPrimitive';
import {AccentSemanticStyles} from './semantic/accentSemanticStyles';
import {AnnotationSemanticStyles} from './semantic/annotationSemanticStyles';
import {AppFrameSemanticStyles} from './semantic/appFrameSemanticStyles';
import {BackgroundSemanticStyles} from './semantic/backgroundSemanticStyles';
import {BorderSemanticStyles} from './semantic/borderSemanticStyles';
import {CellSemanticStyles} from './semantic/cellSemanticStyles';
import {CommentComposerSemanticStyles} from './semantic/commentComposerSemanticStyles';
import {ComposerSemanticStyles} from './semantic/composerSemanticStyles';
import {IconSemanticStyles} from './semantic/iconSemanticStyles';
import {InlineBannerSemanticStyles} from './semantic/inlineBannerSemanticStyles';
import {InputSemanticStyles} from './semantic/inputSemanticStyles';
import {LeftBarSemanticStyles} from './semantic/leftBarSemanticStyles';
import {MessageSemanticStyles} from './semantic/messageSemanticStyles';
import {MetricsSemanticStyles} from './semantic/metricsSemanticStyles';
import {MobileSemanticStyles} from './semantic/mobileSemanticStyles';
import {SearchBarSemanticStyles} from './semantic/searchBarSemanticStyles';
import {SettingsSemanticStyles} from './semantic/settingsSemanticStyles';
import {SidePanelSemanticStyles} from './semantic/sidePanelSemanticStyles';
import {TabSemanticStyles} from './semantic/tabSemanticStyles';
import {TagSemanticStyles} from './semantic/tagSemanticStyles';
import {TextSemanticStyles} from './semantic/textSemanticStyles';
import {ToggleSemanticStyles} from './semantic/toggleSemanticStyles';
import {TooltipSemanticStyles, UpsellTooltipSemanticStyles} from './semantic/tooltipSemanticStyles';
import {TopBarSemanticStyles} from './semantic/topBarSemanticStyles';
import {MobileTypographySemanticStyles, TypographySemanticStyles} from './semantic/typographySemanticStyles';
import {VerticalSwitcherSemanticStyles} from './semantic/verticalSwitcherSemanticStyles';
import {themeConstants} from './themeConstants';

export enum ThemeTypesEnum {
  LIGHT = 'light',
  DARK = 'dark',
  EXPANDED_DARK = 'expandedDark',
  DARK_SIDEBAR = 'darkSidebar',
}

export interface ThemeType {
  type: ThemeTypesEnum;
  hasInboxRedesign: boolean;
  hasDropdownRedesign: boolean;
  hasP0AppSwitcher: boolean;
}

/*
 * Semantic styles implemented as a part of the dark mode expansion. These
 * use the new dark palette in dark mode.
 */
export interface SemanticStyles {
  /** @deprecated Everything is non-rounded now. */
  rounded: boolean;

  /** @deprecated */
  brand: string;

  appBackground: string;
  foreground: string;

  invertedIcon: string;

  indicatorColor: string;

  modalBackdrop: string;

  colorScheme: string;

  windowsButtonHover: string;

  scrollbarTrack: string;
  scrollbarThumb: string;

  typography: TypographySemanticStyles;
  mobileTypography: MobileTypographySemanticStyles;
  mobile: MobileSemanticStyles;
  /** @deprecated Use <Typography> & `typographyMixin` instead. */
  textStyles: TextSemanticStyles;
  icon: IconSemanticStyles;

  cell: CellSemanticStyles;
  topBar: TopBarSemanticStyles;
  searchBar: SearchBarSemanticStyles;
  tab: TabSemanticStyles;
  tag: TagSemanticStyles;
  message: MessageSemanticStyles;
  inlineBanner: InlineBannerSemanticStyles;
  annotation: AnnotationSemanticStyles;
  commentComposer: CommentComposerSemanticStyles;
  leftBar: LeftBarSemanticStyles;
  settings: SettingsSemanticStyles;
  appFrame: AppFrameSemanticStyles;
  tooltip: TooltipSemanticStyles;
  upsellTooltip: UpsellTooltipSemanticStyles;
  sidePanel: SidePanelSemanticStyles;
  background: BackgroundSemanticStyles;
  input: InputSemanticStyles;
  border: BorderSemanticStyles;
  toggle: ToggleSemanticStyles;

  verticalSwitcher: VerticalSwitcherSemanticStyles;

  metrics: MetricsSemanticStyles;

  accent: AccentSemanticStyles;

  defaultInboxColor: string;

  composer: ComposerSemanticStyles;
}

export interface ColorStyles {
  greys: typeof greys | typeof greysDark;
  alphas: typeof alphas;
  palette: typeof palette;
  brandPalette: typeof lightBrandPalette | typeof darkBrandPalette;
}

export interface PrimitiveStyles {
  spacing: typeof spacingPrimitive;
  borderRadius: typeof borderRadiusPrimitive;
}

export interface ColorConstants {
  constants: typeof themeConstants;
}

export interface UserThemeOptions {
  hasInboxRedesign: boolean;
  hasDropdownRedesign: boolean;
  hasP0AppSwitcher: boolean;
}

export type UserTheme = Readonly<
  SemanticStyles & ColorStyles & ThemeType & ColorConstants & PrimitiveStyles & UserThemeOptions
>;
